import { lazy, Suspense, useCallback, useContext } from "react";

import { Loading } from "./Components";
import { Context } from "./context";

const LazyDevMatch = lazy(() => import("../match"));

export const DevMatch = () => {
  const { player, updateContext } = useContext(Context);
  const setInMatch = useCallback((inMatch: boolean) => updateContext({ inMatch }), [updateContext]);

  return <Suspense fallback={<Loading />}>
    <LazyDevMatch player={player} setInMatch={setInMatch} />
  </Suspense>;
};
